import { useTranslation } from 'react-i18next'

const NoToken = () => {
  const { t } = useTranslation(['package-room'])
  return (
    <div className="package-room__content package-room__content--full">
      <h1 className="package-room__title">{t('package-room:noToken.title')}</h1>
      <p className="package-room__description">{t('package-room:noToken.description')}</p>
    </div>
  )
}

export default NoToken
